module.exports = __webpack_public_path__ + "static/media/performante.4862e6af.png";